import { render } from "./GroupListPage.vue?vue&type=template&id=2b83705b&scoped=true&ts=true"
import script from "./GroupListPage.vue?vue&type=script&lang=ts"
export * from "./GroupListPage.vue?vue&type=script&lang=ts"

import "./GroupListPage.vue?vue&type=style&index=0&id=2b83705b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83705b"]])

export default __exports__